// extracted by mini-css-extract-plugin
module.exports = {"collection-title":"collection-title_collection-title__mo3fL","collection-desc":"collection-title_collection-desc__NVJMr","revamp":"collection-title_revamp__JSntT"};